import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GoogleMap from 'react-google-map';

import withGoogleMaps from 'client/helpers/withGoogleMaps';
import { defaultMapOptions } from 'client/constants/mapOptions';

export const SR_GOOGLE_VIEW_MARKET_TYPE_CIRCLE = 'SR_GOOGLE_VIEW_MARKET_TYPE_CIRCLE';
export const SR_GOOGLE_VIEW_MARKET_TYPE_ICON = 'SR_GOOGLE_VIEW_MARKET_TYPE_ICON';

@withGoogleMaps
class SrGoogleViewMarket extends Component {
  static propTypes = {
    googleMaps: PropTypes.object,
    locationLatitude: PropTypes.number.isRequired,
    locationLongitude: PropTypes.number.isRequired,
    streetViewEnabled: PropTypes.bool.isRequired,
    type: PropTypes.oneOf([
      SR_GOOGLE_VIEW_MARKET_TYPE_CIRCLE,
      SR_GOOGLE_VIEW_MARKET_TYPE_ICON,
    ]),
  }

  _onLoadedMap = (googleMaps, map) => {
    const {
      type,
      locationLatitude,
      locationLongitude,
      onClickMap,
    } = this.props;

    this.map = map;

    if (type === SR_GOOGLE_VIEW_MARKET_TYPE_CIRCLE) {
      this.marker = new googleMaps.Circle({
        strokeColor: '#0473EA',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#0473EA',
        fillOpacity: 0.35,
        map: map,
        center: {
          lat: locationLatitude,
          lng: locationLongitude,
        },
        radius: 400,
      });
    }
    else if (type === SR_GOOGLE_VIEW_MARKET_TYPE_ICON) {
      this.marker = new googleMaps.Marker({
        position: {
          lat: locationLatitude,
          lng: locationLongitude,
        },
        map: map,
      });
    }

    this.map.addListener('click', onClickMap);
    if (this.marker) {
      googleMaps.event.addListener(this.marker, 'click', onClickMap);
    }
  }

  render() {
    const {
      googleMaps,
      locationLatitude,
      locationLongitude,
      streetViewEnabled,
      onClickStreeView,
    } = this.props;

    return (
      <div className='SrGoogleViewMarket'>
        <GoogleMap
          googleMaps={googleMaps}
          center={{
            lat: locationLatitude,
            lng: locationLongitude,
          }}
          zoom={13}
          maxZoom='16'
          disableDefaultUI
          gestureHandling='cooperative'
          clickableIcons={false}
          onLoaded={this._onLoadedMap}
          options={defaultMapOptions}
        />

        {streetViewEnabled && (
          <div className='streetview-button' onClick={onClickStreeView}>
            <span>street view</span>
          </div>
        )}
      </div>
    );
  }
}

SrGoogleViewMarket.displayName = 'SrGoogleViewMarket';

export default SrGoogleViewMarket;
